export default theme => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(1) * 2.5
  }
});
